import { ReactElement, SVGProps } from 'react'
export const SvgSearch = (props: SVGProps<SVGSVGElement>): ReactElement => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m21.81 20.912-5.163-5.081a8.168 8.168 0 0 0 2.183-5.55C18.83 5.707 15.062 2 10.415 2 5.767 2 2 5.707 2 10.28c0 4.574 3.767 8.281 8.415 8.281 2.008 0 3.85-.694 5.296-1.849l5.184 5.101a.654.654 0 0 0 .915 0 .63.63 0 0 0 0-.901Zm-11.395-3.625c-3.933 0-7.12-3.137-7.12-7.006 0-3.87 3.187-7.007 7.12-7.007 3.932 0 7.12 3.137 7.12 7.007 0 3.87-3.188 7.006-7.12 7.006Z"
    />
  </svg>
)
